import { render, staticRenderFns } from "./SurveyMatrix.vue?vue&type=template&id=fea33366&scoped=true&"
import script from "./SurveyMatrix.vue?vue&type=script&lang=js&"
export * from "./SurveyMatrix.vue?vue&type=script&lang=js&"
import style0 from "./SurveyMatrix.vue?vue&type=style&index=0&id=fea33366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea33366",
  null
  
)

export default component.exports